// region_home1b(2026-10-18) — 홈 히어로 캐러셀 카드 계약. region-a(src/lib/home/region-scope.ts · homeHeroCandidates)와 맞물리는 자리.
//   모양 = 지금 홈 히어로 원천(lib/home/ds2-home HeroPick: slug·name·meta·badge·image)과 같다 → HeroPick[] 은 그대로 넘어온다.
//   region-a 의 HeroCard 가 같은 키 + scopeChip('전국')이면 page.tsx 한 줄(cards={homeHeroCandidates(...)})로 갈아 끼운다.
//   키가 다르면 toHeroCard 어댑터 한 곳만 고친다(부품은 HeroCard 만 안다).
import type { CardImage } from '@/lib/home/ds2-home';
import type { HeroFeature } from '@/components/ds2';

/** 캐러셀 최대 장수(지시: 상위 5). */
export const HERO_CAROUSEL_MAX = 5;

export interface HeroCard {
  slug: string;
  name: string;
  /** 「지역 · N세대」 등(빈 칸은 호출부가 뺀다). */
  meta: string[];
  /** 흰 태그(「청약 D-3 · 10/19 접수」·「분양예정 · 2026년 중」). */
  badge: string | null;
  /** 없으면 밝은 텍스트 카드(data-noimg · 「{지역} 주요 현장」 정적 카드 등). */
  image: CardImage | null;
  /** 없으면 /apt/{slug}. */
  href?: string | null;
  /** 지역 안에 현장이 없어 전국 순위를 낼 때 「전국」. */
  scopeChip?: string | null;
}

/** 현장 상세 경로(page.tsx siteHref 와 같은 규칙). */
export const heroHref = (slug: string) => `/apt/${encodeURIComponent(slug)}`;

/** 어댑터 — HeroCard 와 키가 같은(또는 더 많은) 아무 객체 → HeroCard. region-a 타입 차이는 여기서만 흡수한다. */
export function toHeroCard(x: HeroCard): HeroCard {
  return { slug: x.slug, name: x.name, meta: x.meta ?? [], badge: x.badge ?? null, image: x.image ?? null, href: x.href ?? null, scopeChip: x.scopeChip ?? null };
}

/** HeroCard → ds2 FeatureCard props(종전 page.tsx 의 feature={…} 매핑 그대로). */
export function heroFeatureOf(c: HeroCard): HeroFeature {
  return {
    title: c.name,
    href: c.href || heroHref(c.slug),
    imageSrc: c.image?.src ?? null,
    imageAlt: c.image?.alt ?? null,
    aiLabel: c.image?.ai ? 'AI 상상도' : null,
    badge: c.badge,
    meta: c.meta,
    scopeChip: c.scopeChip ?? null,
  };
}
